import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: 'Do you offer delivery?',
    answer: 'Yes! We offer free local delivery on eligible orders over $100 within 5km of your nearest store. Order by 4pm for next-day delivery. For further distances or regional WA, contact your local store to arrange postage.'
  }, {
    question: 'How do I choose my local store?',
    answer: 'Use our store selector at the top of the page to pick your nearest Better Pets & Gardens location. You can also browse all six stores on our Stores page.'
  }, {
    question: 'Can I check if a product is available at my store?',
    answer: "You can enquire about product availability by clicking 'Check Store Availability' on any product page, or by calling your local store directly."
  }, {
    question: 'Do all stores carry the same products?',
    answer: 'Our stores carry a wide range of products, but availability can vary by location. Contact your preferred store for specific product enquiries.'
  }, {
    question: 'How does the Customer Care Club work?',
    answer: "It's free to join! Earn points on every purchase, save $10 on big bags of premium pet food, and receive members-only specials. No card needed — just your phone number at checkout."
  }, {
    question: 'Can I get advice before I buy?',
    answer: 'Absolutely! Our staff are trained experts in pet care, gardening and pool maintenance. Visit any store or call us for personalised advice.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="section-padding bg-white" data-id="element-101">
      <div className="container-wide max-w-4xl" data-id="element-102">
        <div className="text-center mb-12" data-id="element-103">
          <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-gray-900 mb-4" data-id="element-104">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600" data-id="element-105">
            Got a question? We're here to help.
          </p>
        </div>

        <div className="space-y-4" data-id="element-106">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`border rounded-2xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-brand-blue shadow-soft' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-107">
                <button className="w-full px-6 py-5 flex items-center justify-between text-left bg-white focus:outline-none" onClick={() => toggleFaq(index)} data-id="element-108">
                  <span className="font-heading font-bold text-lg text-gray-900 pr-8" data-id="element-109">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-brand-blue flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-110" />
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-111">
                  <p className="text-gray-600 leading-relaxed" data-id="element-112">{faq.answer}</p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}